<template>
  <b-row>
    <b-col
      cols="9"
      align-self="start"
    >
      <b-dropdown
        split
        split-variant="outline-primary"
        variant="primary"
        :text="study.textSelection"
        class="mt-1 combobox-config shadow-sm"
        size="sm"
        :disabled="study.disabled"
      >
        <b-dropdown-item
          v-for="option in study.options"
          :key="option.value"
          :value="option.value"
          @click="study.changeSelection(option.text,option.value); setConfigReportModifiedReportViewer()"
        >
          {{ option.text }}
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
    <b-col align-self="end">
      <b-button
        size="sm"
        variant="danger"
        class="p-0 m-0 mr-2 float-right"
        @click="removeStudyCont(study)"
      >
        <b-icon
          icon="x-square-fill"
          aria-label="Remove"
        />
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MutiOptionsSelection',
  props: {
    study:{
      type:Object,
      required: true
    },
    listcontr:{
      type:Array,
      required:true
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
    'getStudiesReportViewer'
  ]),
  methods: {
    ...mapActions([
      'setConfigReportModifiedReportViewer',
      'delStudiesReportViewer'
    ]),
    removeStudyCont (study){ //Remove study from both lists
      this.setConfigReportModifiedReportViewer()
      const indexStudy = this.getStudiesReportViewer.findIndex(studyStr=>studyStr.configId === study.valueConfigId);
            this.delStudiesReportViewer({
                index:indexStudy,
                configKey: study.valueConfigId
            })
      const indexStudyCtrl = this.listcontr.findIndex(studyCtr=>studyCtr.valueConfigId === study.valueConfigId);
            this.$emit('removeElement', indexStudyCtrl)
    },
  }
}
</script>

<style>

</style>
